/* ============================================================
   BGC Marquee — drives the duplicated-span track via
   window.BGC.driveTrack (falls back to a local rAF driver if
   bgc-core.js hasn't loaded yet). Supports multiple section
   instances via data-marquee-track="{{ section.id }}".
   Owned by AGENT-FOOTER.
   ============================================================ */
(function () {
  "use strict";

  function localDriveTrack(track, pxPerSec) {
    var x = 0, paused = false, half = 0, prev = 0;

    function measure() { half = track.scrollWidth / 2; }
    measure();
    window.addEventListener("resize", measure);
    track.addEventListener("mouseenter", function () { paused = true; });
    track.addEventListener("mouseleave", function () { paused = false; });

    function tick(now) {
      if (!prev) prev = now;
      var dt = now - prev;
      prev = now;
      if (!paused && half) {
        x -= pxPerSec * (dt / 1000);
        if (-x >= half) x += half;
        track.style.transform = "translate3d(" + Math.round(x) + "px,0,0)";
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  var tracks = document.querySelectorAll("[data-marquee-track]");
  if (!tracks.length) return;

  tracks.forEach(function (track) {
    if (track.dataset.bgcInit) return;
    track.dataset.bgcInit = "1";

    var id = track.getAttribute("data-marquee-track");
    var sel = '[data-marquee-track="' + id + '"]';

    if (window.BGC && typeof window.BGC.driveTrack === "function") {
      window.BGC.driveTrack(sel, 70);
    } else {
      localDriveTrack(track, 70);
    }
  });
})();
